module.exports = __webpack_public_path__ + "static/media/register.00b0caea.png";